<template>
    <div id="pricing">
        <!-- ======= 1.05 Pricing Area ====== -->
        <div class="pricingArea animated">
            <div class="container">
                <div class="row">
                    <div class="price clearfix">
                        <div class="col-md-3 priceCol col-sm-5 col-sm-offset-1 col-md-offset-0">
                            <div class="singlePrice">
                                <div class="priceHead">
                                    <span class="priceTitle">Personal</span>
                                    <div class="priceImg">
                                        <img src="img/icon/user.png" alt="">
                                    </div>
                                    <div class="currency">$3<span>/mo</span></div>
                                    <p>best for personal use</p>
                                </div>
                                <ul class="priceBody">
                                    <li><i class="icofont icofont-ui-check"></i>10GB Space</li>
                                    <li><i class="icofont icofont-ui-check"></i>1 Free Domain</li>
                                    <li><i class="icofont icofont-ui-check"></i>300GB SSD Disk</li>
                                    <li><i class="icofont icofont-ui-close"></i>Special Offers</li>
                                    <li><i class="icofont icofont-ui-check"></i>Unlimited Support</li>
                                </ul>
                                <a href="" class="priceBtn Btn">Get Started now</a>
                            </div>
                        </div>
                        <div class="col-md-3 priceCol col-sm-5">
                            <div class="singlePrice">
                                <div class="priceHead">
                                    <span class="priceTitle">small team</span>
                                    <div class="priceImg">
                                        <img src="img/icon/users.png" alt="">
                                    </div>
                                    <div class="currency">$7<span>/mo</span></div>
                                    <p>best for personal use</p>
                                </div>
                                <ul class="priceBody">
                                    <li><i class="icofont icofont-ui-check"></i>10GB Space</li>
                                    <li><i class="icofont icofont-ui-check"></i>1 Free Domain</li>
                                    <li><i class="icofont icofont-ui-check"></i>300GB SSD Disk</li>
                                    <li><i class="icofont icofont-ui-close"></i>Special Offers</li>
                                    <li><i class="icofont icofont-ui-check"></i>Unlimited Support</li>
                                </ul>
                                <a href="" class="priceBtn Btn">Get Started now</a>
                            </div>
                        </div>
                        <div class="col-md-3 priceCol col-sm-5 col-sm-offset-1 col-md-offset-0">
                            <div class="singlePrice">
                                <div class="priceHead">
                                    <span class="priceTitle">company</span>
                                    <div class="priceImg">
                                        <img src="img/icon/home.png" alt="">
                                    </div>
                                    <div class="currency">$15<span>/mo</span></div>
                                    <p>best for personal use</p>
                                </div>
                                <ul class="priceBody">
                                    <li><i class="icofont icofont-ui-check"></i>10GB Space</li>
                                    <li><i class="icofont icofont-ui-check"></i>1 Free Domain</li>
                                    <li><i class="icofont icofont-ui-check"></i>300GB SSD Disk</li>
                                    <li><i class="icofont icofont-ui-close"></i>Special Offers</li>
                                    <li><i class="icofont icofont-ui-check"></i>Unlimited Support</li>
                                </ul>
                                <a href="" class="priceBtn Btn">Get Started now</a>
                            </div>
                        </div>
                        <div class="col-md-3 priceCol col-sm-5">
                            <div class="singlePrice">
                                <div class="priceHead">
                                    <span class="priceTitle">big shot</span>
                                    <div class="priceImg">
                                        <img src="img/icon/earth.png" alt="">
                                    </div>
                                    <div class="currency">$25<span>/mo</span></div>
                                    <p>best for personal use</p>
                                </div>
                                <ul class="priceBody">
                                    <li><i class="icofont icofont-ui-check"></i>10GB Space</li>
                                    <li><i class="icofont icofont-ui-check"></i>1 Free Domain</li>
                                    <li><i class="icofont icofont-ui-check"></i>300GB SSD Disk</li>
                                    <li><i class="icofont icofont-ui-close"></i>Special Offers</li>
                                    <li><i class="icofont icofont-ui-check"></i>Unlimited Support</li>
                                </ul>
                                <a href="" class="priceBtn Btn">Get Started now</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- ======= /1.05 Pricing Area ====== -->
    </div>
</template>

<script>
export default {
  name: 'quick-pricing-area'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pricingArea.vue